import ActionsForOfferSubmitted from "./ActionsForOfferSubmitted";

export default ActionsForOfferSubmitted;
